import React from 'react'
import SonraiMappingForm from './SonraiMappingForm';
import SonraiCredentialsForm from './SonraiCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function SonraiConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={SonraiMappingForm}
            CredentialsForm={SonraiCredentialsForm}
            componentName="Account Name"
            componentKey="accountName"
        />
    )
}